import { motion } from 'framer-motion';
import { EnvelopeSimple, Phone, WhatsappLogo, MapPin } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { WHATSAPP_URL } from '../components/FloatingWhatsApp';

const ContactPage = () => (
  <main data-testid="contact-page" className="pt-24 pb-16 min-h-screen bg-[#F7F5F2]" dir="rtl">
    <section className="py-14 bg-[#F5F2EC]">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-[#D8D2C8] text-[#5D6E55] text-xs sm:text-sm mb-4">
          تواصل معنا
        </span>
        <h1 className="text-3xl sm:text-4xl font-bold text-[#1F3D2B] mb-4 font-['IBM_Plex_Sans_Arabic']">
          نسعد بتواصلكم
        </h1>
        <p className="text-[#6B7565] leading-8">
          سواء كان لديكم استفسار، أو رغبة في طلب عرض سعر، أو حجز جلسة استشارية —
          فريقنا جاهز للرد عليكم.
        </p>
      </div>
    </section>

    <section className="py-12">
      <div className="max-w-4xl mx-auto px-4 grid sm:grid-cols-2 gap-5">
        <motion.a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-whatsapp"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-[20px] border border-[#E6E0D6] p-6 flex items-start gap-4 hover:border-[#25D366] transition-colors"
        >
          <div className="w-12 h-12 rounded-2xl bg-[#25D366]/15 flex items-center justify-center shrink-0">
            <WhatsappLogo size={24} weight="fill" className="text-[#25D366]" />
          </div>
          <div>
            <h3 className="font-bold text-[#1F3D2B] mb-1">واتساب</h3>
            <p className="text-sm text-[#6B7565]">
              للتواصل السريع مع Child Horizons | آفاق الطفولة
            </p>
            <p className="text-sm text-[#92A082] mt-2">
              يفتح في تطبيق واتساب مباشرةً
            </p>
          </div>
        </motion.a>

        <motion.a
          href="mailto:info@childhoodhorizons.com"
          data-testid="contact-email"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.05 }}
          className="bg-white rounded-[20px] border border-[#E6E0D6] p-6 flex items-start gap-4 hover:border-[#4A641F] transition-colors"
        >
          <div className="w-12 h-12 rounded-2xl bg-[#F5F2EC] flex items-center justify-center shrink-0">
            <EnvelopeSimple size={24} weight="duotone" className="text-[#1F3D2B]" />
          </div>
          <div>
            <h3 className="font-bold text-[#1F3D2B] mb-1">البريد الإلكتروني</h3>
            <p className="text-sm text-[#6B7565]">للاستفسارات الرسمية والعروض</p>
            <p className="text-sm text-[#1F3D2B] mt-1" dir="ltr">
              info@childhoodhorizons.com
            </p>
          </div>
        </motion.a>

        <div className="bg-white rounded-[20px] border border-[#E6E0D6] p-6 sm:col-span-2">
          <h3 className="font-bold text-[#1F3D2B] mb-4 font-['IBM_Plex_Sans_Arabic']">
            كيف نقدر نساعدك
          </h3>
          <div className="grid sm:grid-cols-2 gap-3">
            <Link to="/quotation">
              <Button className="w-full bg-[#1F3D2B] hover:bg-[#163020] text-white rounded-xl py-3 text-sm">
                اطلب عرض سعر مخصص
              </Button>
            </Link>
            <Link to="/booking">
              <Button
                variant="outline"
                className="w-full border-[#D8D2C8] text-[#1F3D2B] rounded-xl py-3 text-sm"
              >
                احجز جلسة استشارية
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default ContactPage;
